import ConfirmModal from '../UI/Modal/confirmModal';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { deleteOrgPlanMapping } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';

const DeleteOrgPlanMappingModal = ({ setSelectedAction, selectedMapping, setSelectedMapping, getMappings }) => {
    const [loading, setLoading] = useState(false);
    const { userData } = useUserContext();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await deleteOrgPlanMapping(userData?.token, userData?.selectedOrganization?.org_token, selectedMapping._id);
            if (res.status) {
                toast.success(res.message);
                getMappings();
                setSelectedMapping(null);
                setSelectedAction('');
            }
        } catch (error) {
            const errorMessage = error?.response?.data.message || 'Failed to delete the mapping.'
            toast.error(errorMessage);
            console.log('Delete Mapping error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfirmModal
            title="Delete Mapping"
            description="Are you sure you want to delete this mapping?"
            ConfirmText="Delete"
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={handleDelete}
        />
    );
};

export default DeleteOrgPlanMappingModal;